import { FC } from "react";
import WorkspaceSettingsPage from "@web-src/modules/workspace/pages/WorkspaceSettingsPage";
import { CXWorkspaceAdminLayout } from "../CXWorkspaceAdminLayout";

export const CXWorkspaceGeneralPage: FC = () => (
  <CXWorkspaceAdminLayout>
    <WorkspaceSettingsPage useDefaultLayout={false} />
  </CXWorkspaceAdminLayout>
);
